import { GlIcon, GlTooltipDirective } from '@gitlab/ui';
import { __ } from '~/locale';
export default {
    name: 'SidebarConfidentialityContent',
    components: {
        GlIcon
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        confidential: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'expand-sidebar'
    ],
    computed: {
        confidentialIcon () {
            return this.confidential ? 'eye-slash' : 'eye';
        },
        tooltipLabel () {
            return this.confidential ? __('Confidential') : __('Not confidential');
        }
    }
};
